export default __webpack_public_path__ + "static/media/refunded.fd990452.svg";